import { Map, List } from "immutable";
import { STATE_STATUS } from "constants";
import { REGION_DISTRIBUTOR_ACTIONS } from "constants/actions";
import { RegionDataRecord, DistributorListRecord } from "records/region-data-record";
const INITIAL_STATE = new Map({});

export default (state = INITIAL_STATE, { type, payload }) => {
    switch(type) {
    case REGION_DISTRIBUTOR_ACTIONS.FETCH_REGION_DATA:
        return state.setIn([payload.id, "status"], STATE_STATUS.FETCHING);
    case REGION_DISTRIBUTOR_ACTIONS.FETCHED_REGION_DATA:
        return state.setIn([payload.id, "status"], STATE_STATUS.FETCHED)
            .setIn([payload.id, "data"], new List(payload.data).map(_ => new RegionDataRecord(_)));
    case REGION_DISTRIBUTOR_ACTIONS.FAILED_FETCH_REGION_DATA:
        return state.setIn([payload.id, "status"], STATE_STATUS.FETCH_FAILED);
    case REGION_DISTRIBUTOR_ACTIONS.FETCH_REGION_WISE_DATA:
        return state.setIn([payload.id, "distributors", "status"], STATE_STATUS.FETCHING);
    case REGION_DISTRIBUTOR_ACTIONS.FETCHED_REGION_WISE_DATA:
        return state.setIn([payload.id, "distributors", "status"], STATE_STATUS.FETCHED)
            .setIn([payload.id, "distributors", "data"], new List(payload.data.map(_ => new DistributorListRecord(_))));
    case REGION_DISTRIBUTOR_ACTIONS.FAILED_FETCH_REGION_WISE_DATA:
        return state.setIn([payload.id, "distributors", "status"], STATE_STATUS.FETCH_FAILED);
    case "LOGOUT":
        return INITIAL_STATE;
    default:
        return state;
    }
};